/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import axios from 'axios'
import { injectable } from 'inversify'
import { IImportBatchUIApiClient } from './contracts'
import { SettingsManager } from '../../configuration/SettingsManager'
import { injectProperty } from '../../arc/configuration/ServiceLocator'
import { IUserSessionMiddleware } from '../../arc/middleware/UserSessionMiddleware/contracts'
import { ICoverageDiscoveryBatchRequest, IBatchExcelUploadResponse, IContinueBatchUpload } from '../ImportBatchUIStateManager/contracts'
import { ErrorHelper } from '../../utils/ErrorHelper'

@injectable()
export class ImportBatchUIClient implements IImportBatchUIApiClient {
	@injectProperty('IUserSessionMiddleware')
	private readonly userSessionMiddleware!: IUserSessionMiddleware

	saveItem(item: ICoverageDiscoveryBatchRequest): Promise<IBatchExcelUploadResponse> {
		const dateTimeStamp = `t=${Date.now()}`
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}/batches/importbatchui?${dateTimeStamp}`
		const formData = new FormData()
		formData.append('file', item.File)
		formData.append('name', item.batchName)
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.post(url, formData, {
					headers: {
						Authorization: `Bearer ${token}`,
						'content-type': 'multipart/form-data',
					},
				}),
			)
			.then(response => response.data)

			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}

	sendSuccessfulRowsData(item: IContinueBatchUpload): Promise<void> {
		const dateTimeStamp = `t=${Date.now()}`
		const url = `${SettingsManager.REACT_APP_MAIN_API_BASE_URL().value}/batches/sendSuccessData?${dateTimeStamp}`
		return this.userSessionMiddleware
			.loadSessionJwt()
			.then(token =>
				axios.post(url, item, {
					headers: {
						Authorization: `Bearer ${token}`,
					},
				}),
			)
			.then(response => response.data)

			.catch(error => {
				ErrorHelper.handleApiError(error)
			})
	}
}
